import type { NextPage } from "next";
import Image from "next/image";
import type { HTMLAttributes } from "react";

import { convertToKebabCase } from "@/utils/common/convertHelper/convertToKebabCase";
import { cn } from "@/utils/common/styleHelper/utils";

interface LoadingGotherPropsInterface extends HTMLAttributes<HTMLDivElement> {
  isOverlay?: boolean;
  imageClass?: string;
}
const LoadingGother: NextPage<LoadingGotherPropsInterface> = ({
  isOverlay = true,
  imageClass,
  className,
  ...props
}) => {
  const classOverlay =
    "fixed inset-x-0 top-0 mx-auto flex h-screen w-screen z-[100]";
  const classDefault = "relative object-cover";
  const selectClass = isOverlay ? classOverlay : classDefault;

  return (
    <div
      {...props}
      id={convertToKebabCase("LoadingGother")}
      role="status"
      className={cn(selectClass, className)}
    >
      <Image
        src="https://d31jk6ljx7wihh.cloudfront.net/images/loading.gif"
        alt="loading"
        className={imageClass || "m-auto w-full max-w-[300px]"}
        width={1920}
        height={1080}
        unoptimized
      />
    </div>
  );
};

export default LoadingGother;
